import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "integrations-blue",
  "use": "integrations-blue-usage",
  "viewBox": "0 0 219 50",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 219 50\" id=\"integrations-blue\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 36.381c6.098 4.993 12.875 8.82 20.176 11.05 22.878 7.009 50.927-1.718 80.326-10.865 8.162-2.54 16.428-5.11 24.716-7.387 9.139-2.494 18.305-4.625 27.316-6.72C176.761 16.829 199.861 11.459 218.275 0H0v36.381z\" fill=\"#8AC6FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol